module.exports = __webpack_public_path__ + "img/information.3b5e4458.png";